import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { Api } from '@app/providers';
import { catchError } from 'rxjs/operators';

@Injectable()
export class UnauthorizedResolver implements Resolve<Observable<Response>> {
  constructor(private api: Api) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<Response> {
    return this.api
      .rpc({
        repository: 'projects',
        handler: 'all',
      })
      .pipe(catchError((error: Response) => of(error)));
  }
}
